<template>
  <div v-if="show" class="q-pa-lg">
    <div class="text-body1 text-weight-bold q-mb-sm">
      Request New Posts
    </div>
    <p class="text-body1">
      Send the client a request to import their latest
      <strong>{{ account.socialSite.name }}</strong> posts.
    </p>
    <app-user v-slot="{ isCustomer }">
      <p v-if="isCustomer" class="text-body1">
        You will be notified by email when the posts are available for your review.
      </p>
    </app-user>
    <create-request-btn :account="account" class="q-mt-md" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account } from '@/social/types';
import AppUser from '@/auth/AppUser.vue';
import CreateRequestBtn from './action/reconnect/CreateRequestBtn.vue';

export default defineComponent({
  components: { AppUser, CreateRequestBtn },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  computed: {
    show(): boolean {
      return (
        this.account.socialSite.auth === null
        && this.account.reconnectRequest === null
      );
    },
  },
});
</script>
